// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3x3LZ","label":"Labeled_label__3tLDW","divider":"Labeled_divider__zGNNB"};